export default __webpack_public_path__ + "82aaf4ad112eb8a289961694af9ff5f9.svg";